export default __webpack_public_path__ + "static/media/06.0de8522e.jpg";